// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const PackageIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 40 40">
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
      d="M20.64 37.55 4.95 28.73V11.1l15.69 8.82z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
      d="m20.63 37.55 15.7-8.82V11.1l-15.7 8.82z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
      d="m36.34 11-15.8 9-15.59-8.9 15.59-8.23zM12.43 15.18l15.43-8.55"
    />
    <path
      fill="currentColor"
      d="M36.78 10.99a1.1 1.1 0 0 0-.6-.99L20.4 1.9a1 1 0 0 0-1 0L3.8 10.14a1 1 0 0 0-.22.21 1 1 0 0 0-.16.17q-.1.15-.1.33v17.89a1.1 1.1 0 0 0 .55.95l15.7 8.81a1.1 1.1 0 0 0 1.06 0l15.7-8.81a1.1 1.1 0 0 0 .55-.95V10.99zm-13.95 6.1L20 18.67l-6.08-3.33 13.33-7.39 6.17 3.19zm-2.93-13L25 6.67 11.67 14l-5.1-2.86zM5.38 12.97l13.54 7.72v15L5.38 28.1zM34.62 28.1l-13.54 7.6V20.57l2.84-1.67 10.7-6z"
    />
  </svg>,
  "Package",
);
export default PackageIcon;
